<template>
  <div class="container">
    <section class="section">
      Translation status: {{ callStatus }}
      <br />
      Twitter post id: {{ tweetData.tweet_id }}
      <br />
      Original Url
      <a :href="tweetData.called_url">{{ tweetData.called_url }}</a>
      <br />
      The translated tweet:
    </section>
    <div class="section1" v-html="translatedData"></div>
    <div class="section2" id="twizzle">
      <br />
      <div v-if="ready === false">
        <input
          type="text"
          placeholder="Enter a tweet name"
          :ref="'tweet_name'"
          :value="tweet_name"
        />
        <button @click.prevent="clear">Clear</button>
        <button @click.prevent="share">Share on Twitter</button>
      </div>
      <div v-else></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable*/
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
    data(){
        return {
            concept1:"concept one, two, three",
            content: [],
            tweet_name: '',
            qstring: '',
            tweet_text:'',
            tweet_mention:'',
            ready : false
        }
    },
    mounted(){
        window.twttr = (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
    if (d.getElementById(id)) return t;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function(f) {
    t._e.push(f);
  };

  return t;
}(document, "script", "twitter-wjs"));
    },
    computed:{
        ...mapGetters(['getApiStatus','getApiData', 'getTweetData']),
        callStatus(){
            return this.getApiStatus;
        },
        translatedData(){
            let temp = this.getApiData;
            this.content = temp.split("results:")
            return this.content[1];
        },
        tweetData(){
            return this.getTweetData;
        }


    },
    methods:{
        clear(){
            //add action to clear state and call getter
            this.$router.push('/')
        },
        share(){
            let card_header = `<html>
    <head><meta name="twitter:card" content="summary"></meta>
    <meta name="twitter:site" content="@slow_band" />
    <meta name="twitter:title" content="slow_band_contrast" />
    </head>
    <body>`
            let card_content = card_header+this.content[1];
            const formdata = new FormData();
            formdata.append('html', card_header+this.content[1])
            formdata.append('name', this.$refs.tweet_name.value)
            axios.post("https://slow-band-v1.herokuapp.com/api/upload", formdata).then(res =>{
                this.qstring = res.data;
                this.ready = true;
                twttr.widgets.createShareButton(
                    this.qstring,
                    document.getElementById('twizzle'),
                    {
                        text: 'What your post looks like on rural internet',
                        dnt: true,
                        hashtags: "ruralinternet,internetutility"
                    }

                );
            })
            //creates a tweet and calls out the original tweeter in it
        },
        prep_tweet(){
            
        }
    }
    
}
</script>
<style lang="sass">
$font-stack:    Arial, sans-serif
$primary-color: #333

</style>